var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right"},[_c('div',{staticClass:"ShuiYinRight1"},[_vm._v(_vm._s(_vm.enterpriseName)+" ")]),_c('div',{staticClass:"outStudy_out",staticStyle:{"margin-left":"15px"},on:{"click":function($event){return _vm.SignOut()}}},[_c('img',{attrs:{"src":require("../assets/outStudy.png"),"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }